export default __webpack_public_path__ + "static/media/osobni-doucovani-banner.03337d27.png";